import React from 'react';

function Button({ children, className = '', variant = 'primary', ...props }) {
  return (
    <button className={`ui-btn ui-btn--${variant} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
}

export default Button;
